import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Divider,
  Box
} from '@mui/material';

interface FAQItem {
  q: string;
  a: string;
}

interface FAQDialogProps {
  open: boolean;
  onClose: () => void;
}

const FAQDialog = ({ open, onClose }: FAQDialogProps) => {
  const faqList: FAQItem[] = [
    {
      q: 'Do you store my personal data?',
      a: 'Only the minimum required to activate your account.'
    },
    {
      q: 'Can I use an anonymous name?',
      a: 'Yes, you may use any identity you prefer.'
    },
    {
      q: 'How do I delete my data?',
      a: 'You can delete your account anytime from settings.'
    }
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: '1.4rem',
          color: 'primary.main',
          borderBottom: '2px solid #eee',
          pb: 2
        }}
      >
        FAQ
      </DialogTitle>

      <DialogContent sx={{ py: 3 }}>
        {faqList.map((item, i) => (
          <Box key={i} sx={{ mb: 3 }}>
            <Typography fontWeight={700} sx={{ mb: 0.5 }}>
              {item.q}
            </Typography>

            <Typography color="text.secondary">{item.a}</Typography>

            {i < faqList.length - 1 && <Divider sx={{ mt: 2 }} />}
          </Box>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default FAQDialog;
